// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  grudgeId: __t.u64().primaryKey().name("grudge_id"),
  versonaId: __t.u64().name("versona_id"),
  targetId: __t.u64().name("target_id"),
  worldId: __t.u64().name("world_id"),
  causeText: __t.string().name("cause_text"),
  intensity: __t.u32(),
  offenses: __t.u32(),
  lastRuminatedAt: __t.timestamp().name("last_ruminated_at"),
  createdAt: __t.timestamp().name("created_at"),
});
